/**
 * Goal card loading skeleton — pulse animation.
 */

import React from 'react'

export const GoalCardSkeleton: React.FC = () => (
  <div className="space-y-3">
    {[1, 2, 3].map((i) => (
      <div
        key={i}
        className="rounded-2xl bg-white/[0.03] border border-white/[0.06] p-4 animate-pulse"
      >
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-xl bg-white/[0.06]" />
          <div className="flex-1 space-y-1.5">
            <div className="h-4 w-2/3 rounded bg-white/[0.06]" />
            <div className="h-3 w-1/3 rounded bg-white/[0.04]" />
          </div>
        </div>
        <div className="h-2 rounded-full bg-white/[0.06] mb-2" />
        <div className="h-12 rounded-xl bg-white/[0.04]" />
      </div>
    ))}
  </div>
)
